export function getScaleMax(maxAngle, yField, data) {
  var yData = data.map(function (item) {
    return item[yField];
  }).filter(function (v) {
    return v !== undefined;
  });
  var maxValue = yData.length > 0 ? Math.max.apply(Math, yData) : 0;
  var formatRadian = Math.abs(maxAngle) % 360;

  if (!formatRadian) {
    return maxValue;
  }

  return maxValue * 360 / formatRadian;
}